import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function CountdownTimer() {
  // Start at 23:59:42
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 42);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center space-x-2 font-mono font-bold text-white bg-black/20 px-3 py-1 rounded-md" data-id="element-16">
      <Timer className="w-4 h-4 text-white/80" data-id="element-17" />
      <span data-id="element-18">
        {format(hours)}:{format(minutes)}:{format(seconds)}
      </span>
    </div>;
}